import React from 'react'
import Tab from 'react-bootstrap/Tab'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Nav from 'react-bootstrap/Nav'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

class MailingList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      description: "",
      emails: [],
      emailInputValue: "",
      isEditingName: false,
      isEditingDescription: false,
      descriptionInputValue: "",
      nameInputValue: "",
    }
  }
  componentDidMount()
  {
    this.setState({
      name: this.props.mailingList.name,
      description: this.props.mailingList.description,
      emails: this.props.mailingList.emails,
      descriptionInputValue: this.props.mailingList.description,
      nameInputValue: this.props.mailingList.name
    })
  }

  addEmail(email)
  {
    if (!(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)))
    {
      DP_FLASH([{ type: 'danger', message: "Invalid email" }])
      return false;
    }

    const newEmails = [...this.state.emails];
    newEmails.push(email)

    $.ajax({
      url: "/datapulse/admin/mailing_lists/" + this.props.mailingList.id,
      type: "put",
      data: {
        mailing_list: {
          emails: newEmails
        }
      },
      dataType: 'json',
      success: (data) => {
        this.setState({ emails: newEmails });
        DP_FLASH([{ type: 'success', message: 'Email successfully added' }])
      },
      error: (data) => {
        DP_FLASH([{ type: 'danger', message: 'Failed to add email' }])
      }
    })
  }

  removeEmail(email)
  {
    const newEmails = this.state.emails.filter((e) => e != email);

    $.ajax({
      url: "/datapulse/admin/mailing_lists/" + this.props.mailingList.id,
      type: "put",
      data: {
        mailing_list: {
          emails: newEmails
        }
      },
      dataType: 'json',
      success: (data) => {
        this.setState({ emails: newEmails });
        DP_FLASH([{ type: 'success', message: 'Email successfully removed' }])
      },
      error: (data) => {
        DP_FLASH([{ type: 'danger', message: 'Failed to remove email' }])
      }
    })
  }

  updateDescription(desc) {
    $.ajax({
      url: "/datapulse/admin/mailing_lists/" + this.props.mailingList.id,
      type: "put",
      data: {
        mailing_list: {
          description: desc
        }
      },
      dataType: 'json',
      success: (data) => {
        this.setState({ description: desc });
        DP_FLASH([{ type: 'success', message: 'Description successfully changed' }])
      },
      error: (data) => {
        DP_FLASH([{ type: 'danger', message: 'Failed update description' }])
      }
    })
  }

  updateName(name) {
    $.ajax({
      url: "/datapulse/admin/mailing_lists/" + this.props.mailingList.id,
      type: "put",
      data: {
        mailing_list: {
          name: name
        }
      },
      dataType: 'json',
      success: (data) => {
        this.setState({ name: name });
        DP_FLASH([{ type: 'success', message: 'Name successfully changed' }])
      },
      error: (data) => {
        DP_FLASH([{ type: 'danger', message: 'Failed update name' }])
      }
    })
  }

  render() {
    return (
      <div className="mailing-list inner-box">
        <div style={{display: this.state.isEditingName ? "none" : "block"}}>
          <h5 style={{display: "inline"}}>{this.state.name}</h5>
          <button className="bg-transparent" onClick={(e) => this.setState({isEditingName: true})}>
            <i className="fas fa-pencil-alt"></i>
          </button>
        </div>
        <div style={{display: this.state.isEditingName ? "block" : "none"}}>
          <Form.Control
            defaultValue={this.state.name}
            onChange={(e) => this.setState({nameInputValue: e.target.value})}
          >
          </Form.Control>
          <Button className="ml-auto" variant="warning" onClick={(e) => this.setState({isEditingName: false})}>Cancel</Button>
          <Button className="ml-auto" variant="success"
            onClick={(e) => {
              this.setState({isEditingName: false})
              this.updateName(this.state.nameInputValue)
            }}
          >
            Save
          </Button>
        </div>
        <div className="py-3">
          <p style={{display: this.state.isEditingDescription ? "none" : "inline"}}>
            {this.state.description}
            <button className="bg-transparent" onClick={(e) => this.setState({isEditingDescription: true})}>
              <i className="fas fa-pencil-alt"></i>
            </button>
          </p>
          <div style={{display: this.state.isEditingDescription ? "block" : "none"}}>
            <Form.Control as="textarea"
              defaultValue={this.state.description}
              onChange={(e) => this.setState({descriptionInputValue: e.target.value})}
            >
              
            </Form.Control>
            <Button variant="warning" onClick={(e) => this.setState({isEditingDescription: false})}>Cancel</Button>
            <Button variant="success"
              onClick={(e) => {
                this.setState({isEditingDescription: false})
                this.updateDescription(this.state.descriptionInputValue)
              }}
            >
              Save
            </Button>
          </div>
        </div>
        <Row noGutters={true} >
          <Col sm={12} md={8}>
            <Form.Control size="sm" className="emailAdd" placeholder="" onChange={(e) => this.setState({emailInputValue: e.target.value})} />
          </Col>
          <Col sm={12} md={4}>
            <Button variant="success" size="sm" onClick={(e) => this.addEmail(this.state.emailInputValue) } block>
              +Add Email
            </Button>
          </Col>
        </Row>
        <div>
          <ul className="d-flex flex-column">
            {
              this.state.emails.map( (email) => {
                return (
                  <li key={email} className="">
                    <button className="bg-transparent" onClick={(e) => this.removeEmail(email)}>
                      <i className="fas fa-minus-circle color-danger"></i>
                    </button>
                  <span>{email}</span>
                  </li>
                )
              })
            }
          </ul>
        </div>
        <Button className="float-right" variant="danger" onClick={(e) => this.props.deleteMailingList(this.props.mailingList.id)}>Delete</Button>
      </div>
    );
  }
}

export default MailingList;